import React, { useEffect, useState } from 'react';
import {
  DetailExceptionContainer,
  DetailExceptionWrapper,
  DetailExceptionHeader,
  DetailExceptionHeaderTitle,
  DetailExceptionHeaderArea,
  DetailExceptionContent,
  DetailExceptionSubtitle,
  DetailExceptionGrid,
  DetailExceptionGridCol,
  DetailExceptionStrong,
  DetailExceptionSpan,
  DetailExceptionGridRow,
  DetailExceptionGridIconArea,
  DetailExceptionGridIcon,
  DetailExceptionButtonArea
} from './styles';
import { P, H4 } from '../../components/Typography/styles';
import { Form, FormRow, FormFooter } from '../../components/FormTemplate/styles';
import { useHistory, useLocation } from 'react-router';
import colors from '../../assets/styles/colors';
import { getSolicitationById } from '../../services/solicitations';
import { getExceptionsById, updateException, backToDataSolicitation, postExceptions, omitException } from '../../services/exceptions';
import Select from '../../components/Select';
import { useForm, Controller } from 'react-hook-form';
import InputDefault from '../../components/InputDefault';
import InputFile from '../../components/InputFile';
import ModalAction from '../../components/ModalAction';
import Loader from '../../components/Loader';
import { BsBookmark, BsCheck, BsExclamation } from 'react-icons/bs';
import { DefaultLargeButton, SecondaryLargeButton, TertiaryLargeButton } from '../../components/Buttons/styles';
import { useDropzone } from 'react-dropzone';
import { dataSolicitationSteps, exceptionStatus } from '../../helpers/enum';
import { formatData } from '../../helpers/date';
import { formatIdentification } from '../../helpers/string';
import { formatPrice } from '../../helpers/price';
import { getDocumentTypes } from '../../services/document';

const DetailExceptionPage = () => {
  const session = JSON.parse(localStorage.getItem('@EC-session'));
  const location = useLocation();
  const history = useHistory();
  const { getRootProps, getInputProps } = useDropzone({ onDrop });
  const { register, errors, control, setValue, watch, handleSubmit } = useForm({
    defaultValues: {
      detail: ''
    }
  });
  const [exception, setException] = useState({});
  const [solicitation, setSolicitation] = useState(null);
  const [showExceptionsStatus, setShowExceptionsStatus] = useState(false);
  const [showDocumentType, setShowDocumentType] = useState(false);
  const [canAddFile, setCanAddFile] = useState(true);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showBackToDataSolicitationModal, setShowBackToDataSolicitationModal] = useState(false);
  const [selectedExceptionStatus, setSelectedExceptionStatus] = useState(null);
  const [documentTypeSelected, setDocumentTypeSelected] = useState(null);
  const [files, setFiles] = useState([]);
  const [documentTypes, setDocumentTypes] = useState([]);
  const [exceptionsStatusList, setExceptionsStatusList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const fields = watch();

  async function initializedStateComponent() {
    try {
      const response = await getDocumentTypes('SOLICITUD_EXCEPCION');
      const solicitationResponse = await getSolicitationById(location.idCredit);
      const exceptionsResponse = await getExceptionsById(location.idCredit, location.idExcepcionSolicitud);
      const filteredExceptionList = await exceptionsResponse.data.solicitudExcepciones.excepcionesSolicitud.map(item => {
        return {
          id: item.excepcion.id,
          idTipo: item.excepcion.idTipo,
          nombre: item.excepcion.nombre,
          respuestas: item.respuestas?.length ? {
            ...item.respuestas[0],
            fechaCreacion: formatData(item?.respuestas[0].fechaCreacion)
          } : {
            estado: 'EN_PROCESO',
            idUsuarioCreacion: 'Pendiente',
            fechaCreacion: 'Pendiente',
            observacion: 'Pendiente',
          }
        }
      })
      setDocumentTypes(response.data);
      setExceptionsStatusList(filteredExceptionList);
      setException(exceptionsResponse.data);
      setSolicitation(solicitationResponse.data);
      setIsLoading(false);
    } catch (error) {
      console.log(error)
      console.log(error.response)
    }
  }

  async function onSubmit() {
    try {
      setIsLoading(true);
      const data = new FormData();
      data.append('idExcepcionSolicitud', selectedExceptionStatus.respuestas.idExcepcionSolicitud);
      data.append('idCredito', location.idCredit);
      data.append('idAsesor', session.idAsesor);
      data.append('observacion', fields.detail);
      data.append('archivoSoporte', files[0], files[0].name);
      await updateException(data);
      setIsLoading(false);
      setShowSuccessModal(true);
    } catch (error) {
      console.log(error.response)
    }
  }

  function setActiveExceptionStatus(exception) {
    setSelectedExceptionStatus(exception);
  }

  function selectedDocumentType(documentType) {
    setDocumentTypeSelected(documentType)
  }

  function onDrop(file) {
    setCanAddFile(false);
    setFiles(file);
  }

  function removeFile() {
    setCanAddFile(true);
    setFiles([]);
  }

  async function setCloseSuccessModal() {
    try {
      setIsLoading(true);
      const exceptionsResponse = await getExceptionsById(location.idCredit, location.idExcepcionSolicitud);
      setException(exceptionsResponse.data);
      setIsLoading(false);
      setShowSuccessModal(false);
    } catch (error) {
      
    }
  }

  async function setNextStep() {
    try {
      const data = {
        idCredito: location.idCredit
      }
  
      await postExceptions(data);
      history.push({
        pathname: '/admin/ap-secure',
        idCredit: location.idCredit
      })
    } catch (error) {
      console.log(error.response)
    }
  }

  async function setBackToDataSolicitation() {
    try {
      setIsLoading(true);
      const data = {
        idCredito: location.idCredit
      }
  
      await backToDataSolicitation(data);
      setIsLoading(false);
      history.push({
        pathname: '/admin/data-solicitation',
        idCredit: location.idCredit,
        step: dataSolicitationSteps.BASIC_DATA
      })
    } catch (error) {
      console.log(error.response)
    }
  }

  async function omitCreditProcess() {
    try {
      setIsLoading(true);

      const data = {
        idCredito: location.idCredit
      }

      await omitException(data);
      setIsLoading(false);
      
      history.push({
        pathname: '/admin/ap-secure',
        idCredit: location.idCredit
      })
    } catch (error) {
      
    }
  }

  useEffect(() => {
    if(!location.idCredit || !location.idExcepcionSolicitud) {
      return history.push('/admin/processed-exceptions')
    }

    initializedStateComponent();
  }, [])

  useEffect(() => {
    setValue('detail', exception.solicitudExcepciones?.observacion);
  }, [selectedExceptionStatus])

  return (
    <DetailExceptionContainer id="detail-exception-page">
      {isLoading && <Loader />}
      <DetailExceptionWrapper>
        <DetailExceptionHeader>
          <DetailExceptionHeaderTitle>Clientes</DetailExceptionHeaderTitle>
          <DetailExceptionHeaderArea>
            <H4 color={colors.textPrimary}>Detalle excepción</H4>
            <P bold color={colors.textPrimary}>
            {solicitation?.cliente.nombres} {solicitation?.cliente.tipoIdentificacion.toUpperCase()}. {solicitation?.cliente.identificacion}
            </P>
          </DetailExceptionHeaderArea>
        </DetailExceptionHeader>
        <DetailExceptionContent>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <DetailExceptionSubtitle>Seleccione una exepción</DetailExceptionSubtitle>
            <FormRow col="1">
              <Select
                error={errors.exception}
                setShow={setShowExceptionsStatus}
                show={showExceptionsStatus}
                defaultValue={selectedExceptionStatus?.nombre}
                setSelected={setActiveExceptionStatus}
                list={exceptionsStatusList}
                placeholder="Seleccionar..."
                label="Seleccionar excepción"
                name="exception"
                id="exception"
                register={register({ required: "Este dato es obligatorio" })} />
            </FormRow>
            {selectedExceptionStatus ? (
              <>
                <FormRow col="1">
                  <DetailExceptionGrid>
                    <DetailExceptionGridRow>
                      <DetailExceptionGridCol>
                        <DetailExceptionStrong>{exception?.cliente.nombres}</DetailExceptionStrong>
                        <DetailExceptionStrong>{exception?.cliente.tipoIdentificacion.toUpperCase()}. {formatIdentification(exception?.cliente.identificacion)}</DetailExceptionStrong>
                      </DetailExceptionGridCol>
                      <DetailExceptionGridCol>
                        <DetailExceptionStrong>Fecha solicitud</DetailExceptionStrong>
                        <DetailExceptionSpan>25/oct/2020</DetailExceptionSpan>
                      </DetailExceptionGridCol>
                      <DetailExceptionGridCol>
                        <DetailExceptionStrong>Monto solicitado</DetailExceptionStrong>
                        <DetailExceptionSpan>{formatPrice(parseInt(exception?.monto))}</DetailExceptionSpan>
                      </DetailExceptionGridCol>
                      <DetailExceptionGridCol>
                        <DetailExceptionStrong>Modalidad de crédito</DetailExceptionStrong>
                        <DetailExceptionSpan>{exception?.lineaCredito.nombre}</DetailExceptionSpan>
                      </DetailExceptionGridCol>
                      <DetailExceptionGridCol>
                        <DetailExceptionStrong>Tipo de excepción</DetailExceptionStrong>
                        <DetailExceptionSpan>{selectedExceptionStatus?.nombre}</DetailExceptionSpan>
                      </DetailExceptionGridCol>
                    </DetailExceptionGridRow>
                  </DetailExceptionGrid>
                </FormRow>
                <FormRow col="1">
                  <Controller
                    type="text"
                    as={InputDefault}
                    control={control}
                    label="Detalle Excepción (Opcional)"
                    name="detail"
                    id="detail"
                    register={register}
                    error={errors.detail}
                    value={exception.solicitudExcepciones?.observacion} />
                </FormRow>
                <FormRow col="1">
                  <DetailExceptionGrid>
                    <DetailExceptionGridRow>
                      <DetailExceptionGridCol>
                        <DetailExceptionStrong>Usuario aprobador</DetailExceptionStrong>
                        <DetailExceptionSpan>{selectedExceptionStatus?.respuestas.idUsuarioCreacion}</DetailExceptionSpan>
                      </DetailExceptionGridCol>
                      <DetailExceptionGridCol>
                        <DetailExceptionGridIconArea>
                          <DetailExceptionGridIcon background={exceptionStatus[selectedExceptionStatus?.respuestas.estado]?.background}>
                            <BsBookmark size={22} color={colors.white} />
                          </DetailExceptionGridIcon>
                          <DetailExceptionGridCol>
                            <DetailExceptionStrong>Resultado</DetailExceptionStrong>
                            <DetailExceptionSpan>{exceptionStatus[selectedExceptionStatus?.respuestas.estado]?.nombre}</DetailExceptionSpan>
                          </DetailExceptionGridCol>
                        </DetailExceptionGridIconArea>
                      </DetailExceptionGridCol>
                      <DetailExceptionGridCol>
                        <DetailExceptionStrong>Fecha gestión</DetailExceptionStrong>
                        <DetailExceptionSpan>{selectedExceptionStatus?.respuestas.fechaCreacion}</DetailExceptionSpan>
                      </DetailExceptionGridCol>
                    </DetailExceptionGridRow>
                    <DetailExceptionGridRow>
                      <DetailExceptionGridCol>
                        <DetailExceptionStrong>Observaciones</DetailExceptionStrong>
                        <DetailExceptionSpan>{selectedExceptionStatus?.respuestas.observacion}</DetailExceptionSpan>
                      </DetailExceptionGridCol>
                    </DetailExceptionGridRow>
                  </DetailExceptionGrid>
                </FormRow>
                {exceptionStatus[selectedExceptionStatus?.respuestas.estado]?.nombre === exceptionStatus.NEGADA?.nombre && (
                  <DetailExceptionButtonArea>
                    <TertiaryLargeButton type="button" onClick={() => setBackToDataSolicitation()}>Validar datos solicitud</TertiaryLargeButton>
                  </DetailExceptionButtonArea>
                )}
                <FormRow col="1">
                  <Select
                    error={errors.documentType}
                    setShow={setShowDocumentType}
                    show={showDocumentType}
                    defaultValue={documentTypeSelected?.nombre}
                    setSelected={selectedDocumentType}
                    list={documentTypes}
                    placeholder="Seleccionar..."
                    label="Tipo de documento"
                    name="documentType"
                    id="documentType"
                    register={register({ required: "Este dato es obligatorio" })} />
                </FormRow>
                <FormRow col="1">
                  <InputFile
                    getInputProps={getInputProps}
                    getRootProps={getRootProps}
                    canAddFile={canAddFile}
                    files={files}
                    removeFile={removeFile}
                    description="Elige un archivo PNG, JPEG o JPG, o arrasta aqui." />
                </FormRow>
              </>
            ): ''}
            <FormFooter justify="space-between">
              <DefaultLargeButton type="button" id="back-step" onClick={() => setShowBackToDataSolicitationModal(true)}>Cancelar proceso crédito</DefaultLargeButton>
              {exceptionStatus[exception?.solicitudExcepciones?.estado]?.nombre === exceptionStatus.APROBADA?.nombre ? (
                <SecondaryLargeButton type="button" onClick={() => setNextStep()}>Continuar</SecondaryLargeButton>
              ) :  (
                <SecondaryLargeButton type="submit">Actualizar excepción</SecondaryLargeButton>
              )}
            </FormFooter>
          </Form>
        </DetailExceptionContent>
          <ModalAction
            open={showSuccessModal}
            setShowModal={setShowSuccessModal}
            actionFunctionUpButton={() => setCloseSuccessModal()}
            title="¡Muy bien!"
            actionLabelFunctionUpButton="Cerrar"
            description="Se ha actualizado exitosamente la excepción, debes estar pendiente de la respuesta por parte del administrador. "
            backgroundIcon={colors.textHyperlink}
            bodyIcon={<BsCheck size={32} color={colors.white} />} />
            <ModalAction
          open={showBackToDataSolicitationModal}
            setShowModal={setShowBackToDataSolicitationModal}
            actionFunctionUpButton={() => omitCreditProcess()}
            actionFunctionDownButton={() => setShowBackToDataSolicitationModal(false)}
            title="¿Deseas Cancelar el proceso de crédito?"
            actionLabelFunctionUpButton="Confirmar"
            actionLabelFunctionDownButton="Cancelar acción"
            description="Esta acción cancela todo el proceso de crédito y por ende es irreversible, lo cual implica que debes iniciar de nuevo todo el proceso de créditro si así lo requieres."
            backgroundIcon={colors.bgTertiary}
            bodyIcon={<BsExclamation size={32} color={colors.white} />} />
      </DetailExceptionWrapper>
    </DetailExceptionContainer>
  )
}

export default DetailExceptionPage;
